module.exports = __webpack_public_path__ + "media/site/images/technologies/elixir-icon-a0d1c0c29749c98dc86c314f1e197189.svg";